// extracted by mini-css-extract-plugin
export default {"wrap":"b118d09162bb","emailBlock":"b92aa113ab77"};